import ColumnsContent from 'components/Hocs/ColumnsContent';
import TopUsers from './TopUsers';
import RightSidebarTopUsers from './RightSidebarTopUsers/RightSidebarTopUsers';

export default ColumnsContent(TopUsers, RightSidebarTopUsers);



// WEBPACK FOOTER //
// ./src/lauoyts/LayoutApp/Content/Users/TopUsers/index.js